import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { logout, useAuth } from "../services/auth";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import NotiBadge from "./Badge";




const settings = ['Profile', 'Account', 'Logout'];

const Logout = () => {
  const [user, loading] = useAuth();
  const navigate = useNavigate();

  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/login");
  }, [user, loading, navigate]);

  return (
    <div className="user-logged-container">
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexGrow: 1 }}>
        <Tooltip title="Open settings" sx={{ marginRight: 'auto' }}>
          <Stack direction = 'row' spacing = {2} alignItems='center' sx={{ position: 'absolute', right: '30px', top: '22px' }}>
            <NotiBadge user = {user}/>
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="" src={user?.photoURL || user?.picture} />
            </IconButton>
            <Typography id="user-logged-title" variant="h6" component="h2" align='left'>
                {user?.displayName || user?.userfullname || user?.name || user?.email}
              </Typography>
          </Stack>

        </Tooltip>
        <Menu
          sx={{ mt: '45px' }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
        >
          {settings.map((setting) => (
            <MenuItem key={setting} onClick={handleCloseUserMenu}>
              <Typography textAlign="center" onClick={() => { if (setting === 'Logout') logout() }}>{setting}</Typography>
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </div>
  );
}

export default Logout;
